import { getInitialFormFunction } from './getInitialForm';

// Import all functions here
const allFunctions = [getInitialFormFunction];

// Build FUNCTION_DEFINITIONS (flat structure, not organized by domain)
export const FUNCTION_DEFINITIONS = allFunctions.reduce((acc, func) => {
    acc[func.key] = func.definition;
    return acc;
}, {});

// Export individual functions for direct use if needed
export { getInitialFormFunction };
